





































import $ from 'jquery';
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { PortalTarget } from 'portal-vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { ZenLink } from 'zenComponents';
import { BBadge } from 'bootstrap-vue';

import GlobalAlerts from '@/components/global_alerts/GlobalAlerts';
import HelpLink from '@/components/help_link/HelpLink';
import Lhn from '@/components/lhn/Lhn.vue';
import { PATHS } from './router/paths';
import ZenModalWrapper from '@/components/zen_modal/ZenModalWrapper.vue';

export default Vue.extend({
  name: 'App',
  components: {
    GlobalAlerts,
    HelpLink,
    Lhn,
    PortalTarget,
    ZenLink,
    ZenModalWrapper,
    BBadge,
  },
  computed: {
    ...mapGetters({
      companyInfo: 'companyInfo',
      currentUser: 'currentUser',
      externalServicesInfo: 'externalServicesInfo',
    }),
    ...mapGetters('modals', {
      activeModal: 'active',
      modalVisible: 'visible',
      modalSize: 'size',
    }),
    containerClasses(): string[] {
      const cls = ['container-fluid'];

      // At the moment we don't have a way for components to tell app which class they
      // want to add to the container.
      if (this.$route.name === PATHS.SURVEY.BUILDER.name) {
        cls.push('container-survey-builder');
      }

      if (this.$route.name === PATHS.NEW_OBJECT.name) {
        cls.push('container-new-object');
      }

      if (
        this.$route.name === PATHS.SETTINGS.AUTHENTICATION.name ||
        this.$route.name === PATHS.SETTINGS.AUTHENTICATION_SAML.name ||
        this.$route.name === PATHS.PROFILE.name
      ) {
        cls.push('flex-container');
      }

      return cls;
    },
  },
  mounted() {
    this.initExternalIntegrations();

    // current redirection for home page TODO: make dynamic
    this.$router.push({ name: 'programScoping' });
  },
  methods: {
    ...mapActions('modals', {
      cancelModal: 'cancel',
    }),
    initExternalIntegrations() {
      this.initSegment();
      this.initIntercom();
      this.initZendesk();
      this.initSentry();
    },
    initSegment() {
      if (!window.analytics) return;

      const host = document.location.host;
      const companyId = this.companyInfo.companyId;

      window.analytics.page();
      window.analytics.identify(this.currentUser.uuid, {
        name: this.currentUser.name,
        email: this.currentUser.email,
        system_wide_role: this.currentUser.systemWideRole,
        company: this.companyInfo.companyName,
        domain: host,
        hostname: host,
        company_id: companyId,
      });
      window.analytics.group(companyId || host, {
        name: this.companyInfo.companyName,
        company_id: companyId,
      });
    },
    initIntercom() {
      if (!window.Intercom) return;

      const appId = this.externalServicesInfo.intercomAppId;
      const companyId = this.companyInfo.companyId;
      const companyName = this.companyInfo.companyName;

      window.intercomSettings = {
        alignment: 'left',
        horizontal_padding: 200,
        vertical_padding: 20,
        app_id: appId,
        name: this.currentUser.name,
        user_id: this.currentUser.uuid,
        email: this.currentUser.email,
        'User Role': this.currentUser.systemWideRole,
        company: {
          company_id: companyId === 'None' ? location.host : companyId,
          name: companyName,
        },
        'Company name': companyName,
      };

      window.Intercom('update', window.intercomSettings);
    },
    initZendesk() {
      if (!window.zE) return;

      window.zESettings = {
        webWidget: {
          position: {
            horizontal: 'left',
            vertical: 'bottom',
          },
          offset: {
            horizontal: '185px',
          },
          color: {
            theme: '#2c94f2',
            header: '#39537a',
          },
        },
      };

      window.zE.identify({
        name: this.currentUser.name,
        email: this.currentUser.email,
        organization: this.companyInfo.companyName,
      });

      // TODO: TEMP for front-end decoupling transition period
      // Necessary since it must also work on legacy frontend pages
      $(document).ready(() => {
        window.zE(() => {
          // Show widget on button click
          $('body').on('click', '.zendesk-widget-link', () => {
            window.zE.activate();
          });
        });
      });
    },
    initSentry() {
      Sentry.init({
        dsn: process.env.VUE_APP_SENTRY_DSN,
        integrations: [
          new Integrations.Vue({
            Vue,
            attachProps: true,
            logErrors: true,
          }),
          new Integrations.CaptureConsole({
            levels: ['error'],
          }),
        ],
      });
    },
  },
});
